module.exports = __webpack_public_path__ + "static/media/atexImage.a716ecdd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/images/atexImage.png
// module id = 346
// module chunks = 0